import { ArrowDownTrayIcon, ShareIcon } from '@heroicons/react/24/outline';
import React, { useState } from 'react';

const QuoteBreakdown = () => {
  const [copied, setCopied] = useState(false);

  const BreakdownDetails = [
    { heading: 'Total Cost', value: '$5100' },
    { heading: 'Quantity', value: '1000' },
    { heading: 'Material', value: 'Aluminum Alloy  7707-T652' },
    { heading: 'Process', value: 'Investment Casting' },
    { heading: 'V&V', value: 'Multiple' },
    {
      heading: 'Estimated Delivery',
      value: 'Sample Shipping by 05/30/2024 and Final Shipping 06/30/2024',
    },
  ];

  const handleShare = () => {
    const link =
      'https://drive.google.com/file/d/1W1UKkxm8FT32DUP84fp-Uy0xsx_hfQGl/view?usp=drive_link';

    navigator.clipboard
      .writeText(link)
      .then(() => {
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, 2000);
      })
      .catch((err) => {
        console.error('Failed to copy:', err);
      });
  };

  const handleDownload = () => {
    const link =
      'https://drive.google.com/file/d/1W1UKkxm8FT32DUP84fp-Uy0xsx_hfQGl/view?usp=drive_link';
    window.open(link, '_blank');
  };

  return (
    <div className="min-w-screen h-full">
      <div className="block p-5 pl-10 bg-white border border-[#DDDDDD] rounded-2xl h-full">
        <div className="flex justify-between relative">
          <h5 className="tracking-tight text-violet-600 text-[25px] font-bold">
            Quote Breakdown
          </h5>
          <div className="flex flex-row space-x-3">
            <div className="relative" title="Download">
              <ArrowDownTrayIcon
                className="block h-6 w-6 hover:cursor-pointer"
                aria-hidden="true"
                onClick={() => handleDownload()}
              />
            </div>
            <div className="relative" title="Share">
              <ShareIcon
                className="block h-6 w-6 hover:cursor-pointer"
                aria-hidden="true"
                onClick={handleShare}
              />
              {/* Show copied message */}
              {copied && (
                <p className="absolute top-6 left-0 transform -translate-x-1/2 bg-white px-2 py-1 rounded text-violet-600 text-sm font-bold">
                  Copied to clipboard!
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="mt-6 flex flex-col justify-between">
          <div>
            {BreakdownDetails &&
              BreakdownDetails.map((item) => (
                <div
                  key={item?.heading}
                  className="grid grid-cols-4 mt-5 items-center"
                >
                  <div className="text-black text-[18px] text-left font-bold">
                    {item?.heading} :
                  </div>
                  <div className="col-span-3 flex flex-row flex-wrap justify-between">
                    <div className="text-black text-[16px] text-left items-center hover:cursor-default">
                      {item?.value}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuoteBreakdown;
